const PageLeaveCollectUrlList = [
  '/physicalExamination_home' //体检首页页
]

export { PageLeaveCollectUrlList }
